import { useContext, useState } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomCard,
  CustomIcon,
  CustomLeafLetArea,
  TableNullData,
  UserInformation,
} from "../../../../components";
import { ICreateAndUpdateClient } from "../../../../types/client.interface";
import "./index.scss";
import { ICreateAndUpdateCategory } from "../../../../types/category.interface";
import { WEEK_DAY } from "../../../../values/dropdownItems";
import utils from "../../../../utils";
import { useQuery } from "react-query";
import values from "../../../../values";
import api from "../../../../api";
import Row from "../../../../components/CustomView/Row";
import Column from "../../../../components/CustomView/Column";
import { ILatLng } from "../../../../types/area.interface";

const Body = (data: any) => {
  const { resultWorkTime, setSelectedWorkTime, setShowModal, allArea } =
    useContext(Context.WorkTimeScreen);

  const [defaultLatLngArea, setDefaultLatLngArea] = useState<ILatLng>({
    lat: 36.92448,
    lng: 50.641372,
  });

  const coords = allArea?.data?.result?.map((item: any) => {
    return { coords: item?.coords, title: item?.name };
  });

  const workTimes = resultWorkTime?.data?.result?.docs;

  const onEdit = (category: ICreateAndUpdateCategory) => {
    setSelectedWorkTime!(category);
    setShowModal!("UPDATE");
  };
  const onRemove = (category: ICreateAndUpdateCategory) => {
    setSelectedWorkTime!(category);
    setShowModal!("DELETE");
  };
  const onClickHandler = (lanLng: [number, number]) => {
    console.log(lanLng);
    setDefaultLatLngArea({ lat: lanLng[0], lng: lanLng[1] });
  };

  const workTimesWithCompleteTitle =
    utils.workTimeWithCompeleteTitle(workTimes);

  return (
    <Row className="row-align-start" id="work-times-body-list">
      <Column medium={5} className="work-time-list-wrapper">
        {(workTimes?.length <= 0 || !data) && <TableNullData />}
        {(workTimes?.length > 0 || !data) &&
          allArea?.data?.result?.map(
            (item: any) =>
              workTimesWithCompleteTitle?.filter(
                (workTimeItem: any) => workTimeItem?.city === item?._id
              ).length > 0 && (
                <div
                  className="category-container"
                  onClick={() => onClickHandler(item?.coords?.[0])}
                >
                  <div className="cityTitle">{item?.name}</div>
                  <ul className="category-container-ul">
                    {workTimesWithCompleteTitle
                      ?.filter(
                        (workTimeItem: any) => workTimeItem?.city === item?._id
                      )
                      ?.map((workTime: any, index: number) => {
                        return (
                          <li key={`work-time-${index}`}>
                            <CustomCard
                              item={workTime}
                              fieldName="completeName"
                              editable
                              removable
                              onEdit={onEdit}
                              onRemove={onRemove}
                            />
                          </li>
                        );
                      })}
                  </ul>
                </div>
              )
          )}
      </Column>
      <Column medium={7}>
        <CustomLeafLetArea
          items={coords}
          defaultLatLngArea={defaultLatLngArea}
        />
      </Column>
    </Row>
  );
};

export default Body;
